// Defines local icons used by the Sentinel workspace.

interface AstroidProps {
  className?: string;
  /** Figma uses the filled star for the AI markers and the outline in trace rows. */
  filled?: boolean;
}

export function Astroid({ className, filled = false }: AstroidProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M12.983 21.186a1 1 0 0 1-1.966 0 10 10 0 0 0-8.203-8.203 1 1 0 0 1 0-1.966 10 10 0 0 0 8.203-8.203 1 1 0 0 1 1.966 0 10 10 0 0 0 8.203 8.203 1 1 0 0 1 0 1.966 10 10 0 0 0-8.203 8.203" />
    </svg>
  );
}

/** The check-circle on the header's Close button and Closed pill (Figma 1095:58193, 1095:58179). */
export function CloseTicketIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d="M5.25 7L6.41667 8.16667L8.75 5.83333M12.8333 7C12.8333 10.2217 10.2217 12.8333 7 12.8333C3.77834 12.8333 1.16667 10.2217 1.16667 7C1.16667 3.77834 3.77834 1.16667 7 1.16667C10.2217 1.16667 12.8333 3.77834 12.8333 7Z" />
    </svg>
  );
}

const USER_HEAD_AND_BODY =
  'M9.33333 12.25V11.0833C9.33333 10.4645 9.0875 9.871 8.64992 9.43342C8.21233 8.99583 7.61884 8.75 7 8.75H3.5C2.88116 8.75 2.28767 8.99583 1.85008 9.43342C1.4125 9.871 1.16667 10.4645 1.16667 11.0833V12.25M7.58333 4.08333C7.58333 5.372 6.53866 6.41667 5.25 6.41667C3.96134 6.41667 2.91667 5.372 2.91667 4.08333C2.91667 2.79467 3.96134 1.75 5.25 1.75C6.53866 1.75 7.58333 2.79467 7.58333 4.08333Z';

/** The person with a plus (Assign to me) or, with `minus`, without the bar (Unassign). Figma 1085:55654. */
export function AssignTicketIcon({ minus = false, className }: { minus?: boolean; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d={`${USER_HEAD_AND_BODY}M12.8333 6.41667H9.33333${minus ? '' : 'M11.0833 4.66667V8.16667'}`} />
    </svg>
  );
}

/** The follow-up bell, from the ticket menu's "Follow up" item (Figma 1070:52673). */
export function FollowupIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      <path d="M6.84538 14C6.96241 14.2027 7.13072 14.371 7.33341 14.488C7.53609 14.605 7.76601 14.6666 8.00004 14.6666C8.23408 14.6666 8.464 14.605 8.66668 14.488C8.86937 14.371 9.03768 14.2027 9.15471 14M11.3334 11.3334H2.66674C2.53754 11.3334 2.41111 11.2959 2.30283 11.2254C2.19455 11.155 2.10908 11.0545 2.05682 10.9364C2.00455 10.8182 1.98775 10.6874 2.00845 10.5599C2.02915 10.4324 2.08646 10.3136 2.17341 10.218C3.06008 9.30404 4.00008 8.3327 4.00008 5.33337C3.99998 4.93991 4.05794 4.54858 4.17208 4.17204M1.33333 1.33333L14.6667 14.6667M5.77865 2.00666C6.38097 1.60445 7.0812 1.37332 7.8046 1.33795C8.52801 1.30257 9.24744 1.46427 9.88614 1.80579C10.5248 2.14731 11.0588 2.65584 11.4311 3.2771C11.8034 3.89837 12 4.60906 12 5.33333C12 7.12466 12.5133 8.43533 13.138 9.36666" />
    </svg>
  );
}
